import { useApiClient } from '@/hooks/useApiClient'
import type { components } from '@/types/api/v1'
import { useMemo } from 'react'
import { useScheduleItems } from '../Context/ScheduleItems/ScheduleItemsContext'
import { ScheduleItemsContextProvider } from '../Context/ScheduleItems/ScheduleItemsContextProvider'
import { ScheduleGrid } from '../Grid/ScheduleGrid'
import { DayCellRenderer } from './DayCellRenderer'
import { TractorInfoCellRenderer } from './TractorInfoCellRenderer'

export function TractorScheduleGrid() {
  const apiClient = useApiClient()
  const { data, isLoading } = apiClient.useQuery('post', '/tractor/all')
  const rows = useMemo(
    () =>
      data?.map((x) => ({
        ...x,
        name: x.tractor_number,
      })),
    [data]
  )
  return (
    <ScheduleItemsContextProvider rows={rows} isLoading={isLoading}>
      <InnerTractorScheduleGrid />
    </ScheduleItemsContextProvider>
  )
}

type RowType = components['schemas']['TractorView']

function InnerTractorScheduleGrid() {
  const { rows, isLoading } = useScheduleItems<RowType>()

  return (
    <ScheduleGrid
      title='Tractor Schedule'
      infoCell={TractorInfoCellRenderer}
      dayCell={DayCellRenderer}
      rows={rows}
      primaryKey='tractor'
      isLoading={isLoading}
    />
  )
}
